import httpService from './httpService';
import { getAuthHeader } from '../utils/utils';
import { postQuestionUrl } from '../constants/apiEndPoints';

export function postQuestionAPI(formData) {
    const headers = getAuthHeader();
    return httpService.post(postQuestionUrl, formData, headers);
}
